import { RefSystemeIrrigation } from './ref-systeme-irrigation.model';
import { RefProtectionGel } from './ref-protection-gel.model';
import { RefProtectionGrele } from './ref-protection-grele.model';
import { RefCultureBio } from './ref-culture-bio.model';
import { RefForme } from './ref-forme.model';
import { RefSituation } from './ref-situation.model';
import { RefModeConduite } from './ref-mode-conduite.model';
import { ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class CaracteristiqueParcelle {
    static jsonMap = {
        id: { key: 'id', optional: true },
        refSystemeIrrigation: { key: 'refSystemeIrrigation', converter: new (ClassConverterFactory.build(RefSystemeIrrigation))(), optional: true },
        refProtectionGel: { key: 'refProtectionGel', converter: new (ClassConverterFactory.build(RefProtectionGel))(), optional: true },
        refProtectionGrele: { key: 'refProtectionGrele', converter: new (ClassConverterFactory.build(RefProtectionGrele))(), optional: true },
        refCultureBio: { key: 'refCultureBio', converter: new (ClassConverterFactory.build(RefCultureBio))(), optional: true },
        refForme: { key: 'refForme', converter: new (ClassConverterFactory.build(RefForme))(), optional: true },
        refSituation: { key: 'refSituation', converter: new (ClassConverterFactory.build(RefSituation))(), optional: true },
        refModeConduite: { key: 'refModeConduite', converter: new (ClassConverterFactory.build(RefModeConduite))(), optional: true },
        derogationTaille: { key: 'derogationTaille', optional: true }
    };

    public id: number = undefined;
    public refSystemeIrrigation: RefSystemeIrrigation = undefined;
    public refProtectionGel: RefProtectionGel = undefined;
    public refProtectionGrele: RefProtectionGrele = undefined;
    public refCultureBio: RefCultureBio = undefined;
    public refForme: RefForme = undefined;
    public refSituation: RefSituation = undefined;
    public refModeConduite: RefModeConduite = undefined;
    derogationTaille: boolean;
}
